<dx-popup
  [showTitle]="true"
  [title]="dialogTitle()"
  [visible]="displayDialog()"
  (onHidden)="closeDialog()"
  [width]="600"
  [height]="'auto'"
  [resizeEnabled]="true"
  [showCloseButton]="true">

  <form novalidate>

    <div class="dialog-line">
      <div class="label" title="Site">Site <span class="danger-color">*</span></div>
      <div class="value">
        <dx-select-box
          [dataSource]="findAllLocalSites()"
          displayExpr="libelle"
          valueExpr="id"
          [value]="formData().site?.id"
          placeholder="Sélectionner le site..."
          (onSelectionChanged)="onChangeField('site', $event.selectedItem)">
        </dx-select-box>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label" title="Libellé">Libellé <span class="danger-color">*</span></div>
      <div class="value">
        <dx-text-box
          class="inputfield"
          placeholder="Libellé"
          [value]="formData().libelle"
          (onValueChanged)="onChangeField('libelle', $event.value)">
        </dx-text-box>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label" title="Code">Code <span class="danger-color">*</span></div>
      <div class="value">
        <dx-text-box
          class="inputfield"
          placeholder="Code"
          [value]="formData().code"
          (onValueChanged)="onChangeField('code', $event.value)">
        </dx-text-box>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label" title="Facture">Facture</div>
      <div class="value">
        <dx-number-box
          class="inputfield"
          placeholder="Facture"
          [max]="999999999"
          [value]="formData().facture"
          (onValueChanged)="onChangeField('facture', $event.value)">
        </dx-number-box>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label" title="Variation de stock">Variation de stock</div>
      <div class="value">
        <dx-number-box
          class="inputfield"
          placeholder="Variation de stock"
          [max]="999999999"
          [value]="formData().variationStock"
          (onValueChanged)="onChangeField('variationStock', $event.value)">
        </dx-number-box>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label" title="Stock">Stock</div>
      <div class="value">
        <dx-number-box
          class="inputfield"
          placeholder="Stock"
          [max]="999999999"
          [value]="formData().stock"
          (onValueChanged)="onChangeField('stock', $event.value)">
        </dx-number-box>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label" title="Actif">Actif</div>
      <div class="value">
        <dx-check-box
          [value]="formData().actif"
          (onValueChanged)="onChangeField('actif', $event.value)">
        </dx-check-box>
      </div>
    </div>

    <div class="dialog-line">
      <div class="custom-button-container-right">
        <yo-button
          tooltip="Enregistrer le compte comptable"
          iconClass="fas fa-save"
          [theme]="ButtonThemeEnum.SAVE"
          [disabled]="!isFormValid()"
          (onClick)="save()">
        </yo-button>
        <yo-button
          tooltip="Fermer"
          (onClick)="closeDialog()"
          iconClass="fas fa-times"
          [theme]="ButtonThemeEnum.CANCEL">
        </yo-button>
      </div>
    </div>

  </form>
</dx-popup>
